import React from 'react';
import { Button } from '@mui/material';

const WizardBackButton = ({ onClick }) => (
  <Button
    onClick={onClick}
    sx={{
      minHeight: 40,
      mr: 0.5,
      px: 1.5,
      color: 'text.secondary',
      fontWeight: 500,
      '&:hover': {
        color: 'text.primary',
        bgcolor: 'action.hover',
      },
    }}
  >
    Back
  </Button>
);

export default WizardBackButton;
